export const ACCESS_TOKEN_NAME = "clap:accessToken";
export const REFRESH_TOKEN_NAME = "clap:refreshToken";

export const ClapVersion = "1.4.1";

export enum ROLE {
  ADMIN = "ADMIN",
  CLAP_MANAGER = "CLAP_MANAGER",
  ACCOUNTS = "ACCOUNTS",
  MANAGER = "MANAGER",
}

// In cleint, pyament calculation status cell is also connected
export enum UploadStatus {
  QUEUED = "QUEUED", // Map, Delete
  MAPPING = "MAPPING",
  MAPPED = "MAPPED", // Process, Delete
  PROCESSING = "PROCESSING",
  FAILED = "FAILED", // Delete
  PROCESSED = "PROCESSED",
  DELETING = "DELETING"
}

export enum PaymentCalculationStatus {
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
}

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum ContributorType {
  ARTIST = "ARTIST",
  LYRICIST = "LYRICIST",
  COMPOSER = "COMPOSER",
}

export const RawDataType = [
  {
    label: "Valid",
    value: "true",
  },
  {
    label: "Invalid",
    value: "false",
  },
];

export const ClientTypes = [
  {
    label: "Label",
    value: "LABEL",
  },
  {
    label: "Artist",
    value: "ARTIST",
  },
  {
    label: "Lyricist",
    value: "LYRICIST",
  },
  {
    label: "Composer",
    value: "COMPOSER",
  },
  {
    label: "Right Holder",
    value: "RIGHTHOLDER",
  },
  {
    label: "On behalf",
    value: "ONBEHALF",
  },
];

export enum AccountType {
  LABEL = "Label",
  MEMBER = "Member",
  ARTIST = "Artist",
  LYRICIST = "Lyricist",
  COMPOSER = "Composer",
  RIGHTHOLDER = "Right Holder",
  CLAP = "CLAP",
}

export enum UserRole {
  CLAP_ADMIN = "Clap Admin",
  CLAP_MANAGER = "CLAP Manager",
  ACCOUNTS = "Accounts",
  MANAGER = "Manager",
}

export enum Currency {
  BDT = "BDT",
  EUR = "EUR",
  USD = "USD",
}

export enum InvoiceStatus {
  DRAFT = "DRAFT",
  INVOICE_SENT = "INVOICE_SENT",
  VOID = "VOID",
  APPROVED = "APPROVED",
  PAID = "PAID",
}

export enum PaymentStatus {
  NEW = "NEW",
  PAID = "PAID",
}

export enum SignupStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum PaymentMethod {
  CASH = "CASH",
  BANK_DEPOSIT = "BANK_DEPOSIT",
}

export enum Actions {
  CREATE = "Create",
  EDIT = "Edit",
  DELETE = "Delete",
  MULTI_DELETE = "Multi Delete",
  CANCEL = "Cancel",
  UPLOAD_FILE = "Upload File",
  RETRIEVE_FILE_COLUMNS = "Retrieve file columns",
  ROW_PROCESS = "Row Process",
  ROW_MAP = "Row Map",
  RETRY = "Retry",
}

export enum BarChartPeriod {
  YEAR = "year",
  MONTH = "month",
}

export enum DateFormat {
  DEFAULT = "YYYY-MM-DD",
}

export enum PageSize {
  DEFAULT = 10,
  FIFTY = 50,
}

export const RequestDefault = {
  pending: true,
  error: false,
  fulfilled: false,
};
export const ResponseDefault = {
  pending: false,
  error: false,
  fulfilled: true,
};
export const ErrorDefault = {
  pending: false,
  error: true,
  fulfilled: false,
};

export const MasterRequiredColumn = [
  // "Label Name",
  "Track Title",
  "Content ID",
  "Net revenue",
];

export const ExcludedMasterKeys = [
  "id",
  "is_valid_data",
  "created_at",
  "updated_at",
  "period",
  // "content_id",
  "sales_file",
];

export const InvoiceDefaultNotes = "Thank you for being with us.";

export enum CurrencySymbol {
  BDT = "৳",
  EUR = "€",
  USD = "$",
}

export enum Cells {
  FILE_ICON_CELL = "file-icon-cell",
  LINK_CELL = "link-cell",
  DATE_CELL = "date-cell",
  FILE_SIZE_CELL = "file-size-cell",
  UPLOAD_STATUS_CELL = "upload-status-cell",
  MUSIC_ICON_CELL = "music-icon-cell",
  ROLE_CELL = "role-cell",
  STATUS_CELL = "status-cell",
  SIGNUP_STATUS_CELL = "signup-status-cell",
  USER_AVATAR_CELL = "user-avatar-cell",
  LABEL_CELL = "label-cell",
  PERCENTAGE_TAG_CELL = "percentage-tag-cell",
  MULTIPLE_PERCENTAGE_TAG_CELL = "multiple-percentage-tag-cell",
  CLIENT_TYPES_CELL = "client-types-cell",
  CLIENT_LOGO_CELL = "client-logo-cell",
  CLIENT_NAME_CELL = "client-name-cell",
  BDT_CELL = "bdt-cell",
  EUR_CELL = "eur-cell",
  USD_CELL = "usd-cell",
  TOTAL_DUE_CELL = "total-due-cell",
  PAYMENT_STATUS_CELL = "payment-status-cell",
  INVOICE_STATUS_CELL = "invoice-status-cell",
  INVOICE_NO_CELL = "invoice-no-cell",
  EXCHANGE_RATE_CELL = "exchange-rate-cell",
  INVOICE_AMOUNT_CELL = "invoice-amount-cell",
  PRIMARY_COLORED_CELL = "primary-colored-cell",
}

export enum SalesDataKeys {
  TITLE = "title",
  DISTRIBUTOR = "distributor_name",
  PLATFORM = "platform_name",
  FROM_DATE = "from_date",
  TO_DATE = "to_date",
  FILE_SIZE = "file_size",
  CREATED = "created_at",
  COMMENT = "comment",
  STATUS = "status",
}

export enum TrackIncomeKeys {
  TITLE = "title",
  PLATFORM = "platform",
  DISTRIBUTOR = "distributor",
  LABEL_NAME = "label",
  ARTIST = "artist",
  LYRICISTS = "lyricists",
  COMPOSERS = "composers",
  QUANTITY = "quantity",
  CURRENCY = "currency",
  BASE_INCOME = "income",
  NET_INCOME = "net_income",
  CLAP_INCOME = "clap_income",
  UPC = "upc",
  ISRC = "isrc",
  LINK = "link",
  PAYABLE = "payable",
  CLIENT_INCOME = "client_income",
}

export enum LabelKeys {
  LABEL_LOGO = "logo",
  LABEL_NAME = "name",
  COUNTRY = "country",
  INCOME_SHARE = "share_percentage",
  LABEL_STATUS = "status",
  LABEL_MODIFIED = "updated_at",
}

export enum ContributorKeys {
  PROFILE_PICTURE = "profile_picture",
  NAME = "name",
  DATE_OF_BIRTH = "date_of_birth",
  EMAIL = "email",
  PHONE = "phone",
  COUNTRY = "country",
  CREATED_AT = "created_at",
}

export enum PlatformKeys {
  NAME = "name",
  CREATED_AT = "created_at",
  MODIFIED = "updated_at",
}

export enum DistributorKeys {
  NAME = "name",
  CREATED_AT = "created_at",
  MODIFIED = "updated_at",
}

export enum ClientKeys {
  CLIENT_LOGO = "client_logo",
  NAME = "name",
  EMAIL = "email",
  CLIENT_TYPES = "client_types",
  INCOME_SHARE = "display_income_share",
  BDT_INCOME = "bdt_income",
  EUR_INCOME = "eur_income",
  USD_INCOME = "usd_income",
  LAST_PAYMENT = "last_payment",
  TOTAL_BDT_DUE = "total_bdt_due",
  TOTAL_EUR_DUE = "total_euro_due",
  TOTAL_USD_DUE = "total_usd_due",
  PAYMENT_CALCULATION_STATUS = "payment_calculation_status",
}

export enum ClientAdjustmentKeys {
  TRACK_TITLE = "track_title",
  CURRENCY = "currency",
  ADJUSTMENT_AMOUNT = "adjusted_amount",
  REASON = "reason",
  CREATED = "created_at",
}

export enum ClientDuesKeys {
  MONTH = "month",
  LAST_PAYMENT = "last_payment",
  BDT_DUE = "taka",
  EUR_DUE = "euro",
  USD_DUE = "usd",
}

export enum PaymentKeys {
  TITLE = "title",
  CREATED = "created_at",
  CLIENT = "client_details.name",
  STATUS = "status",
  MODIFIED = "updated_at",
  CURRENCY = "currency",
  AMOUNT = "amount",
  PAYABLE_BDT = "payable_bdt",
}

export enum InvoiceKeys {
  INVOICE_NO = "invoice.invoice_no",
  INVOICE_DATE = "created_at",
  CLIENT = "client_details.name",
  STATUS = "status",
  EXCHANGE_RATE_ADDED_DATE = "exchange_rate_added_at",
  PAID_DATE = "paid_date",
  CURRENCY = "display_currency",
  INVOICE_AMOUNT = "invoice.invoice_amount",
  EXCHANGE_RATE = "exchange_rate",
  INVOICE_AMOUNT_BDT = "amount_in_bdt",
  REFERENCE = "reference",
}

export enum UserKeys {
  NAME = "name",
  PROFILE_PICTURE = "profile_picture",
  USERNAME = "username",
  CLIENT = "client_name",
  EMAIL = "email",
  USERROLE = "groups",
  USER_STATUS = "status",
  DATE_JOINED = "date_joined",
  MODIFIED = "updated_at",
}

export enum SignupReqKeys {
  NAME = "full_name",
  CATEGORY_TYPE = "category_type",
  EMAIL = "email",
  PHONE = "mobile_no",
  TOTAL_SONGS = "total_songs",
  POPULAR_SONGS = "popular_songs",
  STATUS = "status",
  REQUESTED_DATE = "created_at",
}
